var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9C20 10.5222 19.2191 12.5525 17.8333 15.0469C17.3894 15.846 16.8895 16.6791 16.3437 17.5369C15.5663 18.7584 14.735 19.9698 13.9037 21.1178C13.6127 21.5196 13.3423 21.8851 13.0993 22.2074C12.9526 22.402 12.847 22.5398 12.7894 22.6139L12 23.6288L11.2106 22.6139C11.153 22.5398 11.0474 22.402 10.9007 22.2074C10.6577 21.8851 10.3873 21.5196 10.0963 21.1178C9.26501 19.9698 8.43366 18.7584 7.65634 17.5369C5.36333 13.9336 4 11.0122 4 9C4 4.491 7.53779 1 12 1C16.4622 1 20 4.49101 20 9ZM12 12C10.3431 12 9 10.6569 9 9C9 7.34312 10.3431 6 12 6C13.6569 6 15 7.34312 15 9C15 10.6569 13.6569 12 12 12Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_4110",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9C20 10.5222 19.2191 12.5525 17.8333 15.0469C17.3894 15.846 16.8895 16.6791 16.3437 17.5369C15.5663 18.7584 14.735 19.9698 13.9037 21.1178C13.6127 21.5196 13.3423 21.8851 13.0993 22.2074C12.9526 22.402 12.847 22.5398 12.7894 22.6139L12 23.6288L11.2106 22.6139C11.153 22.5398 11.0474 22.402 10.9007 22.2074C10.6577 21.8851 10.3873 21.5196 10.0963 21.1178C9.26501 19.9698 8.43366 18.7584 7.65634 17.5369C5.36333 13.9336 4 11.0122 4 9C4 4.491 7.53779 1 12 1C16.4622 1 20 4.49101 20 9ZM12 12C10.3431 12 9 10.6569 9 9C9 7.34312 10.3431 6 12 6C13.6569 6 15 7.34312 15 9C15 10.6569 13.6569 12 12 12Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_4110)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFilled);
export default __webpack_public_path__ + "static/media/pin-filled.359990a5fadf9c264c1750dbf21409e8.svg";
export { ForwardRef as ReactComponent };